var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonationWithBorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5358",
    "data-name": "Group 5358",
    transform: "translate(0 -0.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    transform: "translate(0 0.209)",
    fill: "#fff8e4",
    stroke: "#ffc629",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3919",
    "data-name": "Group 3919",
    transform: "translate(35.434 46.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3892",
    "data-name": "Group 3892",
    transform: "translate(0.526 6.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3885",
    "data-name": "Group 3885",
    transform: "translate(1.411 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1455",
    "data-name": "Rectangle 1455",
    width: 28.207,
    height: 70.518,
    transform: "translate(0 27.591) rotate(-78)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886",
    transform: "translate(66.249 15.192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 28.207,
    height: 4.231,
    transform: "translate(0 27.591) rotate(-78)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    transform: "translate(1.411 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1457",
    "data-name": "Rectangle 1457",
    width: 28.207,
    height: 4.231,
    transform: "translate(0 27.591) rotate(-78)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M637.013,728.657a1.411,1.411,0,0,1-.293-.031l-68.977-14.661a1.411,1.411,0,0,1-1.087-1.673l5.865-27.591a1.41,1.41,0,0,1,1.674-1.086l68.977,14.661a1.411,1.411,0,0,1,1.087,1.673l-5.864,27.591a1.41,1.41,0,0,1-1.38,1.117ZM569.71,711.5l66.217,14.075,5.278-24.832-66.217-14.075Z",
    transform: "translate(-566.626 -683.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889",
    transform: "translate(46.697 15.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M839.634,789.771a1.392,1.392,0,0,1-.295-.031l-13.8-2.932a1.41,1.41,0,1,1,.587-2.759l12.652,2.689a4.257,4.257,0,0,1,3.061-1.986L843.7,776a4.251,4.251,0,0,1-1.989-3.062l-12.65-2.689a1.41,1.41,0,1,1,.587-2.759l13.8,2.932a1.411,1.411,0,0,1,1.087,1.672,1.411,1.411,0,0,0,1.087,1.673,1.41,1.41,0,0,1,1.087,1.673l-2.346,11.036a1.4,1.4,0,0,1-1.673,1.086,1.417,1.417,0,0,0-1.675,1.087A1.409,1.409,0,0,1,839.634,789.771Z",
    transform: "translate(-824.427 -767.462)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890",
    transform: "translate(8.658 7.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M631.8,747.686a1.39,1.39,0,0,1-.295-.031l-13.8-2.932a1.411,1.411,0,0,1-1.087-1.672,1.412,1.412,0,0,0-1.085-1.673,1.41,1.41,0,0,1-1.087-1.673l2.346-11.036a1.409,1.409,0,0,1,1.673-1.086,1.411,1.411,0,0,0,1.06-.2,1.393,1.393,0,0,0,.611-.889,1.41,1.41,0,0,1,1.674-1.087l13.8,2.932a1.41,1.41,0,1,1-.587,2.759l-12.649-2.688a4.26,4.26,0,0,1-3.062,1.988l-1.859,8.748a4.252,4.252,0,0,1,1.986,3.059l12.652,2.689a1.41,1.41,0,0,1-.292,2.79Z",
    transform: "translate(-614.423 -725.378)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3891",
    "data-name": "Group 3891",
    transform: "translate(30.3 12.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M741.9,773.433a7.3,7.3,0,0,1-1.521-.16,7.858,7.858,0,0,1-5.316-4.182,10.741,10.741,0,0,1-.907-7.234c1.131-5.323,5.758-8.871,10.33-7.9h0c4.563.97,7.356,6.091,6.225,11.416C749.706,770.109,745.933,773.433,741.9,773.433Zm1.051-16.814c-2.721,0-5.312,2.416-6.035,5.825a7.912,7.912,0,0,0,.643,5.331,5.089,5.089,0,0,0,3.407,2.74c3.034.643,6.176-1.921,6.985-5.725s-1.01-7.424-4.052-8.071h0A4.561,4.561,0,0,0,742.953,756.619Z",
    transform: "translate(-733.903 -753.799)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900",
    transform: "translate(2.689 13.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3893",
    "data-name": "Group 3893",
    transform: "translate(1.41 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1458",
    "data-name": "Rectangle 1458",
    width: 70.518,
    height: 28.207,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894",
    transform: "translate(67.697 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    "data-name": "Rectangle 1459",
    width: 4.231,
    height: 28.207,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3895",
    "data-name": "Group 3895",
    transform: "translate(1.41 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 4.231,
    height: 28.207,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3896",
    "data-name": "Group 3896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M650.494,753.38H579.976a1.41,1.41,0,0,1-1.41-1.41V723.762a1.41,1.41,0,0,1,1.41-1.41h70.518a1.41,1.41,0,0,1,1.41,1.41V751.97A1.41,1.41,0,0,1,650.494,753.38Zm-69.107-2.821h67.7V725.173h-67.7Z",
    transform: "translate(-578.566 -722.352)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3897",
    "data-name": "Group 3897",
    transform: "translate(7.052 5.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M635.832,773.242h-14.1a1.41,1.41,0,0,1-1.41-1.411,1.412,1.412,0,0,0-1.41-1.41,1.41,1.41,0,0,1-1.41-1.41V757.728a1.41,1.41,0,0,1,1.41-1.41,1.412,1.412,0,0,0,1.41-1.41,1.41,1.41,0,0,1,1.41-1.41h14.1a1.41,1.41,0,1,1,0,2.821H622.9a4.253,4.253,0,0,1-2.58,2.579v8.946a4.253,4.253,0,0,1,2.58,2.579h12.934a1.41,1.41,0,0,1,0,2.821Z",
    transform: "translate(-617.497 -753.497)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898",
    transform: "translate(46.542 5.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M851.022,773.242h-14.1a1.41,1.41,0,0,1,0-2.821h12.934a4.252,4.252,0,0,1,2.58-2.579V758.9a4.252,4.252,0,0,1-2.58-2.579H836.918a1.41,1.41,0,0,1,0-2.821h14.1a1.41,1.41,0,0,1,1.41,1.41,1.412,1.412,0,0,0,1.41,1.41,1.41,1.41,0,0,1,1.41,1.41v11.283a1.41,1.41,0,0,1-1.41,1.41,1.412,1.412,0,0,0-1.41,1.41A1.41,1.41,0,0,1,851.022,773.242Z",
    transform: "translate(-835.508 -753.497)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899",
    transform: "translate(28.207 5.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M742.751,773.242c-4.666,0-8.462-4.429-8.462-9.873s3.8-9.873,8.462-9.873,8.462,4.429,8.462,9.873S747.417,773.242,742.751,773.242Zm0-16.924c-3.111,0-5.641,3.164-5.641,7.052s2.53,7.052,5.641,7.052,5.642-3.164,5.642-7.052S745.862,756.318,742.751,756.318Z",
    transform: "translate(-734.289 -753.497)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908",
    transform: "translate(0.526 6.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901",
    transform: "translate(1.411 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1461",
    "data-name": "Rectangle 1461",
    width: 70.518,
    height: 28.207,
    transform: "translate(0 14.661) rotate(-12)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902",
    transform: "translate(66.249 1.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 4.231,
    height: 28.207,
    transform: "translate(0 0.88) rotate(-12)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903",
    transform: "translate(1.411 15.192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1463",
    "data-name": "Rectangle 1463",
    width: 4.231,
    height: 28.207,
    transform: "translate(0 0.88) rotate(-12)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M573.9,728.657a1.41,1.41,0,0,1-1.38-1.117l-5.865-27.591a1.411,1.411,0,0,1,1.087-1.673l68.977-14.661a1.41,1.41,0,0,1,1.673,1.086l5.864,27.591a1.411,1.411,0,0,1-1.087,1.673l-68.977,14.661A1.415,1.415,0,0,1,573.9,728.657Zm-4.191-27.915,5.278,24.832L641.2,711.5l-5.278-24.832Z",
    transform: "translate(-566.626 -683.584)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905",
    transform: "translate(8.658 15.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M621.525,789.77a1.41,1.41,0,0,1-1.38-1.118,1.394,1.394,0,0,0-.611-.889,1.412,1.412,0,0,0-1.06-.2,1.407,1.407,0,0,1-1.673-1.086l-2.346-11.036a1.41,1.41,0,0,1,1.087-1.673,1.411,1.411,0,0,0,1.085-1.673,1.411,1.411,0,0,1,1.087-1.672l13.8-2.932a1.41,1.41,0,1,1,.587,2.759l-12.652,2.689A4.253,4.253,0,0,1,617.456,776l1.859,8.748a4.259,4.259,0,0,1,3.062,1.988l12.649-2.688a1.41,1.41,0,1,1,.587,2.759l-13.8,2.932A1.414,1.414,0,0,1,621.525,789.77Z",
    transform: "translate(-614.423 -767.461)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906",
    transform: "translate(46.697 7.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M829.355,747.679a1.41,1.41,0,0,1-.292-2.79l12.65-2.689a4.252,4.252,0,0,1,1.989-3.062l-1.859-8.748a4.256,4.256,0,0,1-3.061-1.986l-12.652,2.689a1.41,1.41,0,1,1-.587-2.759l13.8-2.932a1.408,1.408,0,0,1,1.672,1.085,1.422,1.422,0,0,0,1.675,1.087,1.4,1.4,0,0,1,1.673,1.086L846.7,739.7a1.41,1.41,0,0,1-1.087,1.673,1.411,1.411,0,0,0-1.087,1.674,1.411,1.411,0,0,1-1.087,1.672l-13.8,2.932A1.394,1.394,0,0,1,829.355,747.679Z",
    transform: "translate(-824.427 -725.37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907",
    transform: "translate(30.3 12.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M742.942,773.434a8.1,8.1,0,0,1-5.013-1.822,11.111,11.111,0,0,1-2.863-13.472,7.859,7.859,0,0,1,5.316-4.183c4.558-.975,9.2,2.573,10.331,7.9a10.746,10.746,0,0,1-.909,7.234,7.86,7.86,0,0,1-5.316,4.182h0A7.407,7.407,0,0,1,742.942,773.434Zm-1.026-16.817a4.568,4.568,0,0,0-.948.1,5.089,5.089,0,0,0-3.407,2.74,8.3,8.3,0,0,0,2.113,9.94,5.091,5.091,0,0,0,4.227,1.116h0a5.089,5.089,0,0,0,3.407-2.74,7.913,7.913,0,0,0,.645-5.331C747.228,759.034,744.636,756.617,741.916,756.617Z",
    transform: "translate(-733.903 -753.796)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909",
    transform: "translate(1.411 1.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    "data-name": "Rectangle 1464",
    width: 70.518,
    height: 28.207,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 28.682)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910",
    transform: "translate(61.967 1.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    "data-name": "Rectangle 1465",
    width: 4.231,
    height: 28.207,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 0, 1.721)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911",
    transform: "translate(1.411 28.372)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1466",
    "data-name": "Rectangle 1466",
    width: 4.231,
    height: 28.207,
    transform: "translate(0 1.721) rotate(-24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912",
    transform: "translate(23.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M692.49,702.019a1.411,1.411,0,0,1-.576-2.7l51.537-22.946-10.326-23.192-6.44,2.868a1.411,1.411,0,0,1-1.149-2.577l7.73-3.442a1.41,1.41,0,0,1,1.862.715L746.6,676.515a1.411,1.411,0,0,1-.713,1.862L693.063,701.9A1.415,1.415,0,0,1,692.49,702.019Z",
    transform: "translate(-691.078 -649.909)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913",
    transform: "translate(0 8.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M576.607,743.487a1.408,1.408,0,0,1-1.289-.837l-11.473-25.769a1.409,1.409,0,0,1,.715-1.862l46.382-20.651a1.411,1.411,0,0,1,1.149,2.577l-45.1,20.078,10.326,23.192,6.443-2.868a1.41,1.41,0,0,1,1.146,2.577l-7.731,3.442A1.416,1.416,0,0,1,576.607,743.487Z",
    transform: "translate(-563.722 -694.246)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914",
    transform: "translate(50.248 5.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M842.537,682.379a1.411,1.411,0,0,1-.574-2.7l2.577-1.147a1.41,1.41,0,1,1,1.146,2.577l-2.577,1.147A1.4,1.4,0,0,1,842.537,682.379Z",
    transform: "translate(-841.125 -678.41)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915",
    transform: "translate(9.884 24.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M628.014,806.89a1.408,1.408,0,0,1-1.289-.837,1.41,1.41,0,0,0-1.862-.714,1.41,1.41,0,0,1-1.862-.715l-4.589-10.308a1.409,1.409,0,0,1,.715-1.862,1.41,1.41,0,0,0,.713-1.862,1.412,1.412,0,0,1,.716-1.862l12.885-5.737a1.41,1.41,0,0,1,1.146,2.577l-11.814,5.26a4.253,4.253,0,0,1-1.308,3.408l3.637,8.169a4.249,4.249,0,0,1,3.408,1.308l11.816-5.26a1.41,1.41,0,0,1,1.146,2.577l-12.885,5.736A1.414,1.414,0,0,1,628.014,806.89Z",
    transform: "translate(-618.289 -782.871)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916",
    transform: "translate(44.813 9.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M819.412,724.55a1.411,1.411,0,0,1-.574-2.7l11.816-5.261a4.255,4.255,0,0,1,1.307-3.4l-3.637-8.171a4.251,4.251,0,0,1-3.407-1.309L813.1,708.966a1.41,1.41,0,0,1-1.146-2.577l12.885-5.737a1.411,1.411,0,0,1,1.862.715,1.409,1.409,0,0,0,1.861.715,1.421,1.421,0,0,1,1.08-.028,1.406,1.406,0,0,1,.782.743l4.589,10.308a1.411,1.411,0,0,1-.714,1.862,1.412,1.412,0,0,0-.715,1.862,1.412,1.412,0,0,1-.716,1.862l-12.885,5.737A1.419,1.419,0,0,1,819.412,724.55Z",
    transform: "translate(-811.117 -700.531)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    transform: "translate(30.64 18.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M742.6,773.971a9.96,9.96,0,0,1-8.736-6.212,10.733,10.733,0,0,1-.616-7.265,7.663,7.663,0,0,1,11.09-4.938,10.735,10.735,0,0,1,4.986,5.318c2.215,4.973.548,10.563-3.713,12.461h0A7.367,7.367,0,0,1,742.6,773.971Zm2.436-1.923h0Zm-4.425-14.568a4.619,4.619,0,0,0-1.885.4,5.091,5.091,0,0,0-2.764,3.388,7.921,7.921,0,0,0,.478,5.349c1.581,3.551,5.18,5.414,8.023,4.148h0c2.841-1.266,3.868-5.185,2.286-8.737a7.92,7.92,0,0,0-3.655-3.934A5.633,5.633,0,0,0,740.609,757.48Z",
    transform: "translate(-732.875 -754.654)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationWithBorder);
export default __webpack_public_path__ + "static/media/donationWithBorder.6190f3ef694a78ded72c4eb081293e5f.svg";
export { ForwardRef as ReactComponent };